export const MARKET_QUERY_OPTIONS = {
	staleTime: 0,
	refetchOnMount: "always" as const,
	refetchOnWindowFocus: false,
}

const MARKET_ROOT = ["market"] as const

export const MARKET_QUERY_KEYS = {
	root: MARKET_ROOT,
	allExchanges: (coin?: string) => [
		...MARKET_ROOT,
		"all-exchanges",
		coin?.toUpperCase() ?? "",
	] as const,
	coinPdp: (symbol?: string) => [
		...MARKET_ROOT,
		"coin-pdp",
		symbol?.toUpperCase() ?? "",
	] as const,
	exchangePdp: (exchange?: string) => [
		...MARKET_ROOT,
		"exchange-pdp",
		exchange?.toUpperCase() ?? "",
	] as const,
	exchangeNames: [...MARKET_ROOT, "exchange-names"] as const,
	coinExchangePdp: (exchange?: string, coin?: string) => [
		...MARKET_ROOT,
		"coin-exchange-pdp",
		exchange?.toUpperCase() ?? "",
		coin?.toUpperCase() ?? "",
	] as const,
}
